const MEETING_REMINDER_WORKER_URL = "/meeting-reminders-sw.js";
const MEETING_REMINDER_WORKER_SCOPE = "/";

export function isMeetingReminderRegistration(registration: ServiceWorkerRegistration): boolean {
  const worker = registration.active ?? registration.waiting ?? registration.installing;
  return worker !== null && new URL(worker.scriptURL).pathname === MEETING_REMINDER_WORKER_URL;
}

function waitUntilActive(registration: ServiceWorkerRegistration): Promise<ServiceWorkerRegistration> {
  const worker = registration.active ?? registration.waiting ?? registration.installing;
  if (!worker || worker.state === "activated") return Promise.resolve(registration);
  return new Promise((resolve, reject) => {
    worker.addEventListener("statechange", () => {
      if (worker.state === "activated") resolve(registration);
      if (worker.state === "redundant") reject(new Error("The reminder worker became redundant"));
    });
  });
}

// Waiting for activation matters because getToken needs an active worker.
export async function registerMeetingReminderWorker(): Promise<ServiceWorkerRegistration> {
  const registration = await navigator.serviceWorker.register(MEETING_REMINDER_WORKER_URL, { scope: MEETING_REMINDER_WORKER_SCOPE });
  return waitUntilActive(registration);
}

export async function findMeetingReminderRegistration(): Promise<ServiceWorkerRegistration | null> {
  const registrations = await navigator.serviceWorker.getRegistrations();
  return registrations.find(isMeetingReminderRegistration) ?? null;
}

export async function unregisterMeetingReminderWorker(): Promise<void> {
  const registrations = await navigator.serviceWorker.getRegistrations();
  await Promise.all(registrations.filter(isMeetingReminderRegistration).map((registration) => registration.unregister()));
}
